import { Input } from '@insta-club/ui';

function AddPageFormStep1() {
    return (
        <>
            <Input name='page' label='آیدی پیج' lang='en' inputType='english' />
        </>
    );
}

export default AddPageFormStep1;

